/**
 * Scan / photo upload caps (trial, Pro monthly limits, per-minute parse throttle).
 * Hard-off while QA/testing — set NEXT_PUBLIC_DISABLE_SCAN_LIMITS=false to enforce billing caps.
 */
export function areScanLimitsDisabled(): boolean {
  const raw =
    process.env.NEXT_PUBLIC_DISABLE_SCAN_LIMITS ??
    process.env.DISABLE_SCAN_LIMITS ??
    "";
  const normalized = String(raw).trim().toLowerCase();
  if (normalized === "false" || normalized === "0" || normalized === "no") return false;
  return true;
}
